// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".editBox[data-v-4d517bf8] {\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  right: -70px;\n  width: 40px;\n  height: 125px;\n  top: 0;\n  align-items: center;\n}\n.editBox > div[data-v-4d517bf8] {\n  cursor: pointer;\n  margin-bottom: 5px;\n  font-size: 25px;\n}", ""]);
// Exports
module.exports = exports;
